/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../../redux/store';
import { capitalizeFirstLetter, removeLastLetter } from 'serenova-js-utils/strings';
import { Button, AutoCompleteField, PlusIconSVG } from 'cx-ui-components';
import { customSortStringMethod } from "../../../../../utils";

const FiltersAutoCompleteWrapper = styled.div`
  display: flex;
  width: 80%;
  margin-left: 25px;
`;
const ActionButton = styled(Button)`
  margin-left: 10px;
  height: 32px;
  padding: 3px 10px;
  background-color: ${(props) => (props.disabled ? '#efefef' : 'inherit')};
`;
const StyledActionButton = styled(ActionButton)`
  margin-left: 0px !important;
`;

export const FiltersAutoCompleteField = ({ index, entity, allOrAny, listItems, suggestions, basicQuery }) => {
  const addedItems = listItems ? listItems.filter((item) => item.tag === 'uuid').map((item) => item.val) : [];
  const options = suggestions ? suggestions.filter(
    (suggestion) => !addedItems.includes(suggestion)
  ).sort(
    (option1, option2) => customSortStringMethod(option1, option2)
  ) : [];
  const entityName = entity && capitalizeFirstLetter(removeLastLetter(entity === 'user-id' ? 'users' : entity));

  const selectedEntityItem = basicQuery.getIn([index, 'selectedFilters', entity, allOrAny, 'val']);
  const isActionBtnDisabled = !selectedEntityItem || suggestions ? !suggestions.includes(selectedEntityItem) : true;

  return (
    <Fragment>
      <FiltersAutoCompleteWrapper>
        <AutoCompleteField
          name={`basicQuery[${[index]}][selectedFilters]${entity}.${allOrAny}[val]`}
          label={`${allOrAny} of these ${entity === 'user-id' ? 'users' : entity}`}
          placeholder={`Select ${entityName}...`}
          suggestedDropDownWidth="100%"
          suggestions={options}
          labelWidth="175px"
          suggestedDropdownStyle={{ width: '300px', overflowX: 'hidden', whiteSpace: 'nowrap' }}
          disabled={false}
          required
        />
        <StyledActionButton
          type="button"
          onClick={() => {
            store.dispatch({ type: 'ADD_FILTER_ITEM', index: index, entity: entity, allOrAny: allOrAny });
          }}
          disabled={isActionBtnDisabled}
          title={`Add ${entityName}`}>
          <PlusIconSVG size={12} plusIconType="secondary" />
        </StyledActionButton>
      </FiltersAutoCompleteWrapper>
    </Fragment>
  );
};

FiltersAutoCompleteField.propTypes = {
  index: PropTypes.number,
  entity: PropTypes.string,
  allOrAny: PropTypes.string,
  listItems: PropTypes.array,
  suggestions: PropTypes.array,
  basicQuery: PropTypes.object,
};
